import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';

/**
 * Use after authGuard on routes that require a verified email.
 * If the user has a valid token but has not verified their email, redirect to the verify-email wall.
 */
export const emailVerifiedGuard: CanActivateFn = (_, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isEmailVerified()) {
    return true;
  }

  router.navigate(['/auth/verify-email'], {
    queryParams: { returnUrl: state.url }
  });
  return false;
};
